import BurstClient from '../clients/reading/BurstClient';
import { FETCH_INTERVENTIONS } from '../actionTypes/reading/apiActionTypes';
import { apiActionCreator } from '../actionCreators';
import selectors from '../../root/shared/root';
import InterventionClient from '../clients/reading/InterventionClient';
import KeycloakClient from '../clients/shared/KeycloakClient';

const fetchInterventions = hasBurstLicense => async (dispatch, getState) => {
    const state = getState();
    const { studentIds = [], schoolId = '' } = selectors.getCommonData(state);

    const additionalApiParams = {
        apiParams: [studentIds, schoolId],
    };
    const isMasUser = KeycloakClient.isMasUser();
    if (hasBurstLicense) {
        await apiActionCreator(
            dispatch,
            FETCH_INTERVENTIONS,
            BurstClient.getInterventions,
            additionalApiParams,
        );
    }
    if (!isMasUser) {
        await apiActionCreator(
            dispatch,
            FETCH_INTERVENTIONS,
            InterventionClient.getInterventions,
            additionalApiParams,
        );
    }
};

export default fetchInterventions;
